import { Directive, ElementRef, HostListener, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[filterMenu]'
})
export class FilterMenuDirective {
  @Output() outsideFilterMenu = new EventEmitter();

  constructor( private elementRef : ElementRef ) { }

  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement) {
    const clickedInside = this.elementRef.nativeElement.contains(targetElement);

    if(!clickedInside) {
      this.outsideFilterMenu.emit(false);
    }
  }
}
